// 天星网站业务页路由（独立命名空间，低耦合注入 test-vue-01）
// 页面清单与原站 tianxing-frontend 保持一致；
// 星盘功能（liliang / plantsLiliang）不移植——
// 由本工程 /onlineChart 的星盘（AstrolabeView + astrolabe_micronaut 后端）承载，
// 网站内所有"星雲鑑计算"入口均跳转 /onlineChart。
// 注意：根路径 / 已改为跳转 /tianxing/home，不再指向星盘。
const Home = () => import(/* webpackChunkName: "tianxing-home" */ './pages/home/index.vue')
const DateSelection = () => import(/* webpackChunkName: "tianxing-date" */ './pages/dateSelection/index.vue')
const DateSelectionService = () => import(/* webpackChunkName: "tianxing-date-service" */ './pages/dateSelection/index_service.vue')
const DateSelectionCustomer = () => import(/* webpackChunkName: "tianxing-date-customer" */ './pages/dateSelection/index_service1.vue')
const DateSelectionClient = () => import(/* webpackChunkName: "tianxing-date-client" */ './pages/dateSelection/index_Client.vue')
const House = () => import(/* webpackChunkName: "tianxing-house" */ './pages/house/index.vue')
const Jizhai = () => import(/* webpackChunkName: "tianxing-jizhai" */ './pages/jizhai/index.vue')
const Siren = () => import(/* webpackChunkName: "tianxing-siren" */ './pages/siren/index.vue')
const Price = () => import(/* webpackChunkName: "tianxing-price" */ './pages/price/index.vue')
const Download = () => import(/* webpackChunkName: "tianxing-download" */ './pages/download/index.vue')
const AutoSelect = () => import(/* webpackChunkName: "tianxing-autoselect" */ './pages/autoSelect/index.vue')
const ArticleDetais = () => import(/* webpackChunkName: "tianxing-article" */ './pages/articleDetais/index.vue')
const TianxingLayout = () => import(/* webpackChunkName: "tianxing-layout" */ './TianxingLayout.vue')

// 嵌套结构：所有 /tianxing/* 页面包在 TianxingLayout 内，
// 统一获得原站全局样式作用域（.tianxing-page）。
const routes = [
  {
    path: '/tianxing',
    component: TianxingLayout,
    children: [
      { path: '', redirect: '/tianxing/home' },
      { path: 'home', name: 'tianxing-home', component: Home },
      { path: 'dateSelection', name: 'tianxing-dateSelection', component: DateSelection },
      { path: 'dateSelectionService', name: 'tianxing-dateSelectionService', component: DateSelectionService },
      { path: 'dateSelectionCustomer', name: 'tianxing-dateSelectionCustomer', component: DateSelectionCustomer },
      { path: 'dateSelectionClient', name: 'tianxing-dateSelectionClient', component: DateSelectionClient },
      { path: 'house', name: 'tianxing-house', component: House },
      { path: 'jizhai', name: 'tianxing-jizhai', component: Jizhai },
      { path: 'siren', name: 'tianxing-siren', component: Siren },
      { path: 'price', name: 'tianxing-price', component: Price },
      { path: 'download', name: 'tianxing-download', component: Download },
      { path: 'autoSelect', name: 'tianxing-autoSelect', component: AutoSelect },
      { path: 'articleDetais', name: 'tianxing-articleDetais', component: ArticleDetais }
    ]
  }
]

export default routes
